import _ from 'lodash';
import React, { useContext, useEffect, useState } from 'react';
import { Dropdown, List } from 'semantic-ui-react';
import UiSaveButtons from '../../../global/components/buttons/UiSaveButtons';
import FullPageWrapper from '../../../global/wrappers/FullPageWrapper';
import Wrapper, { wrapperTypes } from '../../../global/wrappers/Wrapper';
import { SportsSeasonContext } from '../cnr/contexts/SportsSeasonContext';
import { seasonalUpdateTypes } from '../cnr/reducers/reducerHelpers/seasonalSportsData';
import WrapperVertCols from 'global/wrappers/WrapperVertCols';
import MenuVert from 'global/components/menus/MenuVert';
import { listYears } from 'global/lists/lists';
import { useSeasonalData } from '../useHelpers/useSeasonals';

const BackupSeasons = (props) => {

  const { handleCancel, fromDashboard } = props

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state, sportsSeason_handlers } = sportsSeasonContext ?? {}
  const { latestSeason, seasonMatches_info, sportPermissions } = sportsSeason_state ?? {}
  const { matches: matches_season } = seasonMatches_info ?? {}

  const { backupSeasonal } = useSeasonalData()

  const allowUpdate = sportPermissions.any && sportPermissions[seasonalUpdateTypes.backupMatches]

  const [currentYear, setCurrentYear] = useState(latestSeason)

  useEffect(() => {
    // sportsSeason_handlers.handleGet_seasonMatchesForBackup(currentYear)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [currentYear]);

  const handleButtonClick = () => {
    backupSeasonal()
    //  sportsSeason_handlers.handleBackup_seasonMatches(currentYear, matches_season, handleCancel)
  }

  const handleYearChange = (e, data) => setCurrentYear(data.value)

  const buttons = () => {
    const clickOptions_backup = { clickType: 'seasonSchedule', isBackup: true }
    const btns = []
    btns.push({ oc: handleButtonClick, icon: 'save', caption: 'Backup Season (' + latestSeason + ')', color: allowUpdate ? 'green' : 'olive', clickOptions: clickOptions_backup })
    return btns
  }

  const matchItem = (m) => {
    const { _status, startDate, } = m
    const results = m ? m._results : undefined;
    const { matchName } = _status
    const { scoreDisplays } = results ?? {}
    const { full } = scoreDisplays ?? {}
    return <List.Item>
      <List.Content>
        <List.Header >{full ? full : matchName}</List.Header>
        <List.Description >{startDate}</List.Description>
      </List.Content>
    </List.Item>
  }

  const matchHeader = (caption) => {
    return <List.Item>{caption}</List.Item>
  }

  const matchList = () => {
    const dateGroups = _.groupBy(matches_season, 'startDate');

    const mls = _.flatMap(dateGroups, (matches, dgKey) => {
      const collectionKeyMatches = _.groupBy(matches, '_matchCollectionKey');
      return [
        matchHeader(dgKey),
        ..._.flatMap(collectionKeyMatches, (matches_collection, mcKey) => [
          matchHeader(mcKey),
          ..._.map(matches_collection, match => matchItem(match))
        ])
      ];
    });

    return (
      <List divided relaxed>
        {mls}
      </List>
    );
  };

  const wrapperContent = () => {
    const _buttons = buttons()
    return <Wrapper
      content={matches_season ? matchList() : <div>...</div>}
      footer={_buttons && <UiSaveButtons others={_buttons} />}
      wrapperType={wrapperTypes.padded}
    />
  }

  let startYear = 2003;
  let endYear = 2024;

  const ddOpts = Array.from({ length: endYear - startYear + 1 }, (_, i) => ({
    text: (startYear + i - 1) + '-' + (startYear + i),
    value: startYear + i,
    key: startYear + i,
  }))

  const dd = () => <Dropdown
    placeholder='Year'
    selection
    options={ddOpts}
    value={currentYear}
    onChange={handleYearChange}
  >
  </Dropdown>


  const fpw = () => <FullPageWrapper
    content={wrapperContent()}
    topperCaption={'Backup Seasons'}
    topperCaption2={dd()}
    handleCancel={handleCancel}
  ></FullPageWrapper>


  return fromDashboard ? wrapperContent() : fpw()
}

export default BackupSeasons
